// polyfill Promise
const Promise = window.Promise || (function () {
  function PromiseLike (init) {
    let state = 'pending'
    let resolved, error
    const pendingResolve = []
    const pendingReject = []
    function resolve (value) {
      state = 'resolved'
      resolved = value
      pendingResolve.forEach(function (fn) { fn(value) })
    }
    function reject (err) {
      state = 'rejected'
      error = err
      pendingReject.forEach(function (fn) { fn(err) })
    }

    init(resolve, reject)

    return {
      then: function (onResolve) {
        if (state === 'rejected') return this
        return PromiseLike(function (resolve, reject) {
          const wrappedOnResolve = wrapPending(onResolve, resolve, reject)
          if (state === 'resolved') wrappedOnResolve(resolved)
          else pendingResolve.push(wrappedOnResolve)
        })
      },
      catch: function (onReject) {
        if (state === 'resolved') return this
        return PromiseLike(function (resolve, reject) {
          const wrappedOnReject = wrapPending(onReject, resolve, reject)
          if (state === 'rejected') wrappedOnReject(error)
          else pendingReject.push(wrappedOnReject)
        })
      }
    }
  }

  function wrapPending (pending, onResolve, onReject) {
    return function (value) {
      try {
        const pendingResolved = pending(value)
        if (pendingResolved && pendingResolved.then) {
          pendingResolved.then(function (value) { onResolve(value) })
                         .catch(function (err) { onReject(err) })
        } else {
          onResolve(pendingResolved)
        }
      } catch (err) {
        onReject(err)
      }
    }
  }

  PromiseLike.resolve = function (value) {
    return PromiseLike(function (resolve) { resolve(value) })
  }
  PromiseLike.reject = function (err) {
    return PromiseLike(function (resolve, reject) { reject(err) })
  }
  return PromiseLike
})()

// polyfill fetch
const fetch = window.fetch || function (url, options) {
  console.log('Fetching', url)
  options = options || {}
  options.method = options.method || 'GET'
  options.headers = options.headers || {}
  return new Promise(function (resolve, reject) {
    const xhr = new XMLHttpRequest()
    xhr.open(options.method, url)
    Object.keys(options.headers).forEach(function (key) {
      xhr.setRequestHeader(key, options.headers[key])
    })
    xhr.withCredentials = options.credentials === 'include'
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        try {
          const response = Object.create({
            text () {
              return xhr.responseText
            },
            json () {
              return JSON.parse(xhr.responseText)
            }
          })
          response.ok = xhr.status === 200
          response.status = xhr.status
          response.statusText = xhr.statusText
          response.url = xhr.responseURL
          response.headers = xhr.getAllResponseHeaders()
          resolve(response)
        } catch (err) {
          reject(err)
        }
      }
    }
    xhr.onerror = function () { reject(new Error('Network error')) }
    xhr.onabort = function () { reject(new Error('Aborted')) }
    xhr.ontimeout = function () { reject(new Error('Timed out')) }
    xhr.send(options.body)
  })
}

export {Promise, fetch}
